import { create } from 'zustand';

interface WindowSettingsStore {
	windowSizePercent: number;
	setWindowSizePercent: (percent: number) => void;
	windowSizeInMeters: {
		width: number;
		height: number;
	};
	setWindowSizeInMeters: (width: number, height: number) => void;
	snapPointDistance: number;
	setSnapPointDistance: (distance: number) => void;
	highlightedWindowUUID: string | null;
	setHighlightedWindowUUID: (uuid: string | null) => void;
	windowSizeUnit: 'percent' | 'meters';
	setWindowSizeUnit: (unit: 'percent' | 'meters') => void;
}

export const useWindowSettingsStore = create<WindowSettingsStore>((set) => ({
	windowSizePercent: 60,
	setWindowSizePercent: (percent) => set({ windowSizePercent: percent }),
	windowSizeInMeters: { width: 1.2, height: 1.5 },
	setWindowSizeInMeters: (width, height) =>
		set({ windowSizeInMeters: { width, height } }),
	snapPointDistance: 0.5,
	setSnapPointDistance: (distance) => set({ snapPointDistance: distance }),
	highlightedWindowUUID: null,
	setHighlightedWindowUUID: (uuid) => set({ highlightedWindowUUID: uuid }),
	windowSizeUnit: 'percent',
	setWindowSizeUnit: (unit) => set({ windowSizeUnit: unit })
}));
